import { combineReducers } from 'redux';

import translations from './translations';
import globalLoader from './globalLoader';
import globalError from './globalError';
import locationsDetails from './locationsDetails';

export default combineReducers({
  translations,
  globalLoader,
  globalError,
  locationsDetails,
});
